export const menuItems = [
  {
    id: 1,
    label: "menuitems.home.text",
    icon: "bx-home-circle",
    link: "/",
  },
  {
    id: 2,
    label: "menuitems.bookings.text",
    icon: "bx-bookmark",
    link: "/manage-bookings",
  },
  {
    id: 3,
    label: "menuitems.packages.text",
    icon: "bx-package",
    link: "/manage-packages",
  },
  {
    id: 4,
    label: "menuitems.subpackages.text",
    icon: "bxs-package",
    link: "/manage-subpackages",
  },
  {
    id: 5,
    label: "menuitems.extras.text",
    icon: "bx-extension",
    link: "/manage-extras",
  },
  {
    id: 6,
    label: "menuitems.vouchers.text",
    icon: "bxs-coupon",
    link: "/manage-vouchers",
  },
  {
    id: 7,
    label: "menuitems.cafeteria.text",
    icon: "bx-coffee",
    link: "/manage-cafeteria",
  },
  {
    id: 8,
    label: "menuitems.invoices.text",
    icon: "bx-receipt",
    link: "/manage-invoices",
  },
  {
    id: 9,
    label: "menuitems.cms.text",
    icon: "bx-cog",
    subItems: [
      {
        id: 2,
        label: "menuitems.general.text",
        link: "/cms/manage-general",
        parentId: 9,
      },
      {
        id: 3,
        label: "menuitems.homepage.text",
        link: "/cms/manage-homepage",
        parentId: 9,
      },
      {
        id: 4,
        label: "menuitems.cafepage.text",
        link: "/cms/manage-cafepage",
        parentId: 9,
      },
      {
        id: 5,
        label: "menuitems.testimonials.text",
        link: "/cms/manage-testimonials",
        parentId: 9,
      },
      {
        id: 6,
        label: "menuitems.gallery.text",
        link: "/cms/manage-gallery",
        parentId: 9,
      },
    ],
  },
];
